import {Injectable} from '@angular/core';
import {RestUserService} from '@app/core/api/rest.user.service';
import {UserSettingsQuery} from '@app/core/state/user-settings/user-settings.query';
import {PayloadUtil} from '@app/core/util/payload.util';
import {RightUtil} from '@app/core/util/right.util';
import {globalDrawerItems} from '@app/shell/navitems';
import {NavigationSetting, UserSetting} from '@pezi/entities';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {UserSettingsStore} from './user-settings.store';
import {select, setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class UserSettingsService {

  request$ = this.userService.getUserSettings().pipe(
    map(settings => {
      if (PayloadUtil.checkPayload(settings)) {
        return settings.data;
      }
      return null;
    }),
    tap(settings => {
      this.settingsStore.data.update(setProps(settings
      ));
    }));

  constructor(private settingsStore: UserSettingsStore,
              private userService: RestUserService) {
  }


  getSettings(): Observable<UserSetting> {
    const currentSettings = this.settingsStore.data.getValue();
    if (currentSettings.navigation !== undefined && currentSettings.geburtstag !== undefined) {
      return this.settingsStore.data.pipe(select(s => s));
    } else {
      return this.request$;
    }
  }

  storeUserSettings(userSettings: UserSetting): void {
    this.settingsStore.data.update(setProps(userSettings));
  }

  getDefaultNavigationItems(): NavigationSetting[] {
    return this.settingsStore.getDefaultNavigationItems();
  }


  clearSettingsStore() {
    this.settingsStore.data.reset();
  }
}
